import CustomAxiosClient from '@pipltrust/axios-client';
import AppConfig from 'Config/AppConfig';

function getPrefix() {
  let prefix = '';

  if (process.env.NODE_ENV !== 'development') {
    prefix = '/accounts';
  }
  return prefix;
}

export function getBasePath() {
  const prefix = getPrefix();

  return `${prefix}/api`;
}
const BASE_PATH = getBasePath();

const REST = 'rest-c';

const HTTPClient = new CustomAxiosClient({
  baseURL: BASE_PATH,
  enable401Interceptor: true,
  csrfCookieName: AppConfig.CSRF_COOKIE_NAME,
  accountsUrl: getPrefix(),
});

export function checkEmail({ email }) {
  const url = '/onboard/check_email';
  const query = { email };

  return HTTPClient.sendRequest({ method: 'post', url, data: query });
}

export function vettingCheckEmail({ email }) {
  const url = '/vetting/check_email';
  const query = { email };

  return HTTPClient.sendRequest({ method: 'post', url, data: query });
}

export function signUp({ email, firstName, lastName, question, company, phone, password, marketing, recaptcha }) {
  const url = '/signup';
  const data = {
    email,
    first_name: firstName,
    last_name: lastName,
    question,
    company,
    phone,
    password,
    marketing,
    recaptcha,
  };

  return HTTPClient.sendRequest({ method: 'post', url, data });
}

export function leadVetting(params) {
  const url = '/vetting/sign-up/search-trial/';
  const data = { ...params };

  return HTTPClient.sendRequest({ method: 'post', url, data: data.params });
}

export function existingCustomerVetting(params) {
  const url = '/vetting/sign-up/existing-customer-vetting/';
  const data = { ...params };

  return HTTPClient.sendRequest({ method: 'post', url, data });
}

export function eventTracking(data) {
  const url = '/event_tracking';

  return HTTPClient.sendRequest({ method: 'post', url, data });
}

export function setPassword(password) {
  const url = '/set-password/';
  const data = { password };

  return HTTPClient.sendRequest({ method: 'post', url, data, baseURL: getPrefix() });
}

function generateLink(path) {
  let BASE = '';
  if (process.env.NODE_ENV !== 'development') {
    BASE = 'accounts/';
  }

  return `/${BASE}${path}`;
}

async function toggleAdmin(userId) {
  const url = `${REST}/users/${userId}/toggle-admin/`;

  const res = await HTTPClient.sendRequest({ method: 'post', url });

  return res.data;
}

async function assignToTeams({ userId, teams }) {
  const url = `${REST}/teams/add-user-to-teams/`;

  const body = {
    user_id: userId,
    teams,
    is_manager: false,
  };

  const res = await HTTPClient.sendRequest({ method: 'post', url, data: body });

  return res.data;
}

async function bulkAssignToTeams({ users, teams, teamsToUnassign }) {
  const url = `${REST}/teams/bulk-add-users-to-teams/`;

  const body = {
    users,
    teams,
    is_manager: false,
    teams_to_unassign: teamsToUnassign,
  };

  const res = await HTTPClient.sendRequest({ method: 'post', url, data: body });

  return res.data;
}

async function enableTeamManagement() {
  const url = `${REST}/organization/enable-team-management/`;

  const res = await HTTPClient.sendRequest({ method: 'post', url });
  return res.data;
}

async function disableTeamManagement() {
  const url = `${REST}/organization/disable-team-management/`;

  const res = await HTTPClient.sendRequest({ method: 'post', url });
  return res.data;
}

async function assignToSearch(userId) {
  const url = `${REST}/unified-users/bulk-assign-seats/`;

  const body = {
    users: [userId],
    product: 'search',
  };

  const res = await HTTPClient.sendRequest({ method: 'post', url, data: body });

  return res.data;
}

async function unassignToSearch(userId) {
  const url = `${REST}/unified-users/bulk-unassign-seats/`;

  const body = {
    users: [userId],
    product: 'search',
  };

  const res = await HTTPClient.sendRequest({ method: 'post', url, data: body });

  return res.data;
}

async function removeUser(userId) {
  const url = `${REST}/users/${userId}/remove-user/`;
  const res = await HTTPClient.sendRequest({ method: 'post', url });

  return res.data;
}

async function removeUsers(usersIds) {
  const url = `${REST}/unified-users/bulk-remove-users-or-invites/`;

  const body = {
    users: usersIds,
  };
  const res = await HTTPClient.sendRequest({ method: 'post', url, data: body });

  return res.data;
}

async function editProfile({ userId, firstName, lastName }) {
  const url = `${REST}/users/${userId}/edit-profile/`;
  const body = {
    first_name: firstName,
    last_name: lastName,
  };

  const res = await HTTPClient.sendRequest({ method: 'post', url, data: body });

  return res.data;
}

async function resetPassword(userId) {
  const url = `${REST}/unified-users/reset-password/`;
  const body = {
    users: [userId],
  };

  const res = await HTTPClient.sendRequest({ method: 'post', url, data: body });

  return res.data;
}

async function sendReminders(ids) {
  const url = `${REST}/unified-users/send-reminders/`;
  const data = { users: ids };

  const res = await HTTPClient.sendRequest({ method: 'post', url, data });

  return res.data;
}

async function resendConfirmationEmail({ email }) {
  const url = '/vetting/sign-up/resend_confirmation_email/';
  const body = {
    email,
  };

  const res = await HTTPClient.sendRequest({ method: 'post', url, data: body });

  return res.data;
}

async function addUser({ email, firstName, lastName, isAdmin, isPro, teams }) {
  const url = `${REST}/unified-users/bulk-add-users/`;
  const body = {
    users: [
      {
        email,
        first_name: firstName,
        last_name: lastName,
        is_org_admin: isAdmin,
        assign_search: isPro,
        teams,
        product: 'search',
      },
    ],
  };

  const res = await HTTPClient.sendRequest({ method: 'post', url, data: body });

  return res.data;
}

async function addCreditCard(token) {
  const url = `${REST}/organization/billing/add-credit-card/`;
  const body = {
    token,
  };

  const res = await HTTPClient.sendRequest({ method: 'post', url, data: body });

  return res.data;
}

async function addCreditCardOnBoarding(token) {
  const url = `${REST}/organization/billing/add-credit-card-on-boarding/`;
  const body = {
    token,
  };

  const res = await HTTPClient.sendRequest({ method: 'post', url, data: body });

  return res.data;
}

async function toggleActive(userId) {
  const url = `${REST}/users/${userId}/toggle-active/`;

  const res = await HTTPClient.sendRequest({ method: 'post', url });

  return res.data;
}

async function getUsers({ query = '' }) {
  const url = `${REST}/unified-users/all/`;

  const params = { product: 'search' };

  if (query) {
    params.query = query;
  }

  const res = await HTTPClient.sendRequest({ method: 'get', url, params });
  return res.data;
}

async function getInvitations() {
  const url = `${REST}/users/invitations/`;
  const res = await HTTPClient.sendRequest({ method: 'get', url });

  return res.data;
}

async function getUserSummary() {
  const url = `${REST}/users/summary/`;

  const res = await HTTPClient.sendRequest({ method: 'get', url });

  return res.data;
}

async function exportUserList() {
  const url = `${REST}/unified-users/export/`;

  return HTTPClient.sendRequest({ method: 'post', url });
}

async function exportActivationIds(usersIds) {
  const url = `${REST}/activation-links/export/`;

  const data = { users: usersIds };

  const res = await HTTPClient.sendRequest({ method: 'post', url, data });
  return res.data;
}

async function getActivationLink(userId) {
  const url = `${REST}/activation-links/${userId}/`;

  const res = await HTTPClient.sendRequest({ method: 'get', url });
  return res.data;
}

async function getOrganizationDetails() {
  const url = `${REST}/organization/info/`;
  const res = await HTTPClient.sendRequest({ method: 'get', url });

  return res.data;
}

async function getOrganizationIPWhitelist() {
  const url = `${REST}/organization/ip_whitelist/`;
  const res = await HTTPClient.sendRequest({ method: 'get', url });

  return res.data;
}

async function getProfileDetails() {
  const url = `${REST}/profile/info/`;
  const res = await HTTPClient.sendRequest({ method: 'get', url });

  return res.data;
}

function getUseCases() {
  return window.__CONFIG__.USE_CASES;
}

async function changeOrganizationDetails(values) {
  const url = `${REST}/organization/change-details/`;
  const body = {
    name: values.name,
    invoice_email: values.invoice_email,
    phone: values.phone,
    address: values.address,
    city: values.city,
    state: values.state,
    country_code: values.country_code,
    postal_code: values.postal_code,
    vat_id: values.vat_id,
    vetting_use_case: values.use_case_code,
    vetting_use_case_sub_category_text_snapshot: values.vetting_use_case_sub_category_text_snapshot,
    vetting_use_case_category_text_snapshot: values.vetting_use_case_category_text_snapshot,
    vetting_use_case_category_text: values.use_case,
    vetting_use_case_sub_category_text: values.subcategory,
  };

  const res = await HTTPClient.sendRequest({ method: 'patch', url, data: body });
  return res.data;
}

async function setOrganizationDetailsOnboarding(values) {
  const url = `${REST}/organization/set-details-onboarding/`;
  const body = {
    name: values.name,
    invoice_email: values.invoice_email,
    phone: values.phone,
    address: values.address,
    city: values.city,
    state: values.state,
    country_code: values.country_code,
    postal_code: values.postal_code,
  };

  const res = await HTTPClient.sendRequest({ method: 'patch', url, data: body });
  return res.data;
}

async function toggleGoogleLogin() {
  const url = `${REST}/organization/toggle-oauth2/`;

  const res = await HTTPClient.sendRequest({ method: 'post', url, data: { oauth2_type: 'google-oauth2' } });

  return res.data;
}

async function toggleAmazonLogin() {
  const url = `${REST}/organization/toggle-oauth2/`;

  const res = await HTTPClient.sendRequest({ method: 'post', url, data: { oauth2_type: 'amazon' } });

  return res.data;
}

async function toggleOidcLogin() {
  const url = `${REST}/organization/toggle-oauth2/`;

  const res = await HTTPClient.sendRequest({ method: 'post', url, data: { oauth2_type: 'oidc' } });

  return res.data;
}

async function getBillingInformation() {
  const url = `${REST}/organization/billing/`;
  const res = await HTTPClient.sendRequest({ method: 'get', url });

  return res.data;
}

async function fetchInvoices(page) {
  const url = `${REST}/organization/invoices/?page=${page}&product=search`;

  const res = await HTTPClient.sendRequest({ method: 'get', url });

  return res.data;
}

async function changePassword(values) {
  const url = `${REST}/profile/change-password/`;
  const body = {
    old_password: values.oldPassword,
    password: values.newPassword,
  };

  const res = await HTTPClient.sendRequest({ method: 'patch', url, data: body });

  return res.data;
}

async function changeProfileDetails(values) {
  const url = `${REST}/profile/update-details/`;
  const body = {
    first_name: values.first_name,
    last_name: values.last_name,
  };

  const res = await HTTPClient.sendRequest({ method: 'patch', url, data: body });

  return res.data;
}

async function validateEmail({ email }) {
  const url = `${REST}/users/check-email/`;

  const body = {
    email,
  };

  const res = await HTTPClient.sendRequest({ method: 'post', url, data: body });

  return res.data;
}

async function getUserInvites() {
  const url = `${REST}/profile/invites/`;
  const invites = await HTTPClient.sendRequest({ method: 'get', url });

  return invites.data;
}

async function acceptInvite({ inviteId }) {
  const url = `${REST}/profile/accept-invite/`;

  const body = {
    invite_id: inviteId,
  };

  const res = await HTTPClient.sendRequest({ method: 'post', url, data: body });

  return res.data;
}

async function rejectInvite({ inviteId }) {
  const url = `${REST}/profile/reject-invite/`;

  const body = {
    invite_id: inviteId,
  };

  const res = await HTTPClient.sendRequest({ method: 'post', url, data: body });

  return res.data;
}

async function inviteUser({ email, isAdmin, isPro, teams }) {
  const url = `${REST}/users/invite-user/`;

  const body = {
    email,
    is_admin: isAdmin,
    assign_search: isPro,
    product: 'search',
    teams,
  };

  const res = await HTTPClient.sendRequest({ method: 'post', url, data: body });

  return res.data;
}

async function resendInvite({ inviteId }) {
  const url = `${REST}/users/resend-invite/`;

  const body = {
    invite_id: inviteId,
  };

  const res = await HTTPClient.sendRequest({ method: 'post', url, data: body });

  return res.data;
}

async function removeInvite({ inviteId }) {
  const url = `${REST}/users/remove-invite/`;

  const body = {
    invite_id: inviteId,
  };

  const res = await HTTPClient.sendRequest({ method: 'post', url, data: body });
  return res.data;
}

async function exportAuditLogs(timeRange) {
  const url = `${REST}/audit-log/export/`;
  const { startTimestamp, endTimestamp } = timeRange;
  const data = { startTimestamp, endTimestamp };
  return HTTPClient.sendRequest({ method: 'post', url, data });
}

async function uploadUsersFile({ file }) {
  const url = `${REST}/unified-users/upload/`;

  const data = new FormData();
  data.append('file', file, file.name);

  return HTTPClient.sendRequest({ method: 'post', url, data });
}

async function validateCsv(data) {
  const url = `${REST}/unified-users/validate-csv/`;
  return HTTPClient.sendRequest({ method: 'post', url, data });
}

async function asyncBulkAddUsers(users) {
  const url = `${REST}/unified-users/async-bulk-add-users/`;

  const data = { users, product: 'search' };

  return HTTPClient.sendRequest({ method: 'post', url, data });
}

async function addUsers(list) {
  const url = `${REST}/unified-users/bulk-add-users/`;
  const body = {
    users: list,
    product: 'search',
  };

  const res = await HTTPClient.sendRequest({ method: 'post', url, data: body });

  return res.data;
}

async function createTeam(data) {
  const url = `${REST}/teams/`;

  const res = await HTTPClient.sendRequest({ method: 'post', url, data });

  return res.data;
}

async function deleteTeam(teamId) {
  const url = `${REST}/teams/delete/`;
  const data = {
    team_id: teamId,
  };

  const res = await HTTPClient.sendRequest({ method: 'post', url, data });

  return res.data;
}

async function renameTeam(data) {
  const url = `${REST}/teams/rename/`;

  const res = await HTTPClient.sendRequest({ method: 'post', url, data });

  return res.data;
}

async function getUsageData(timeFilter) {
  const url = `${REST}/usage/get-usage-per-user/`;

  const data = { start_date: timeFilter.start_date, end_date: timeFilter.end_date };

  const res = await HTTPClient.sendRequest({ method: 'post', url, data });

  return res.data;
}

async function getUsageExportStatus(requestId) {
  const url = `${REST}/usage/export-status/`;
  const params = { request_id: requestId };
  return HTTPClient.sendRequest({ method: 'get', url, params });
}

async function requestUsageExport(timeFilter) {
  const url = `${REST}/usage/export-request/`;
  const data = { start_date: timeFilter.start_date, end_date: timeFilter.end_date };
  return HTTPClient.sendRequest({ method: 'post', url, data });
}

async function exportUsage(requestId) {
  const url = `${REST}/usage/export-report/`;
  const params = { request_id: requestId };
  return HTTPClient.sendRequest({ method: 'get', url, params });
}

async function getUsageAnalytics(timeRange) {
  const url = `${REST}/usage/get-usage-analytics/`;

  const { start_date, end_date } = timeRange;

  const data = { start_date, end_date };

  const res = await HTTPClient.sendRequest({ method: 'post', url, data });

  return res.data;
}

async function signUpNoVetting(params) {
  const url = `rest/sign-up-post-vetting/token-sign-up/`;
  const data = { ...params };

  return HTTPClient.sendRequest({ method: 'post', url, data: data.params });
}

async function checkPassword({ password }) {
  const url = `${REST}/profile/check-password/`;
  const data = { password };

  return HTTPClient.sendRequest({ method: 'post', url, data });
}

export default {
  generateLink,
  leadVetting,
  checkEmail,
  toggleAdmin,
  vettingCheckEmail,
  signUp,
  eventTracking,
  existingCustomerVetting,
  setPassword,
  getInvitations,
  getUsers,
  getOrganizationDetails,
  getOrganizationIPWhitelist,
  toggleGoogleLogin,
  toggleAmazonLogin,
  toggleOidcLogin,
  changeOrganizationDetails,
  setOrganizationDetailsOnboarding,
  getUseCases,
  getBillingInformation,
  getProfileDetails,
  changePassword,
  changeProfileDetails,
  editProfile,
  toggleActive,
  addUser,
  resetPassword,
  removeUser,
  fetchInvoices,
  addCreditCard,
  addCreditCardOnBoarding,
  exportUserList,
  getUserSummary,
  getUserInvites,
  acceptInvite,
  validateEmail,
  inviteUser,
  rejectInvite,
  resendInvite,
  removeInvite,
  resendConfirmationEmail,
  assignToSearch,
  unassignToSearch,
  sendReminders,
  uploadUsersFile,
  addUsers,
  assignToTeams,
  createTeam,
  deleteTeam,
  renameTeam,
  enableTeamManagement,
  disableTeamManagement,
  getUsageData,
  exportUsage,
  getUsageExportStatus,
  requestUsageExport,
  getUsageAnalytics,
  exportAuditLogs,
  removeUsers,
  bulkAssignToTeams,
  exportActivationIds,
  getActivationLink,
  signUpNoVetting,
  checkPassword,
  HTTPClient,
  validateCsv,
  asyncBulkAddUsers,
};
